import script from "./DropdownList.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownList.vue?vue&type=script&setup=true&lang=js"

import "./DropdownList.vue?vue&type=style&index=0&id=247a7676&lang=scss"

const __exports__ = script;

export default __exports__